import React, { useState, useEffect } from "react";

const IpServerInfo = () => {
   const [text, setText] = useState("");

   useEffect(() => {
      // 1) nếu script ngoài đã nạp config
      
      if (window.__CONFIG__) {
         setText(window.__CONFIG__.message || "");
         return;
      }

      // 2) nếu chưa có thì fetch từ /data/config.json
      let mounted = true;
      async function load() {
         try {
            const res = await fetch("/data/configs.json?t=" + Date.now(), { cache: "no-store",  'Content-Type': "application/json" });     
            if (!res.ok) return;
            const json = await res.json();
            if (mounted) setText(json.message || "");
         } catch (e) {
            /* ignore */
         }
      }
      load();

      // 3) lắng nghe event nếu script injection dùng event để push data
      const onUpdate = (ev) => setText(ev?.detail?.message || "");
      window.addEventListener("config:update", onUpdate);

      return () => {
         mounted = false;
         window.removeEventListener("config:update", onUpdate);
      };
   }, []);

   return (
      <div style={{ padding: "20px" }}>
         <div
            style={{
               backgroundColor: "#f5f5f5",
               padding: "15px",
               borderRadius: "5px",
               fontFamily: "monospace",
            }}
         >
            <div
               id="dynamic-text"
               style={{
                  color: "black",
               }}
            >
               {text || "..."}
            </div>
         </div>
      </div>
   );
};

export default IpServerInfo;
